import { render } from "./scroll-reveal.vue?vue&type=template&id=0dae654a"
import script from "./scroll-reveal.vue?vue&type=script&lang=js"
export * from "./scroll-reveal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__